import React, { useEffect, useState, useRef } from "react";
import PropTypes from "prop-types";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import rehypeRaw from "rehype-raw";
import "./MarkdownStream.css";
import { MotifBadge, MotifTooltip } from "@ey-xd/motif-react";
import _ from "lodash";

function MarkdownWithoutStream(props) {
  const [text, setText] = useState("");
  const markdownRef = useRef();

  useEffect(() => {
    setText(props.markdownText);
  }, [props.markdownText]);

  useEffect(() => {
    if (text) {
      props.setMarkdownResponseHTMLString(markdownRef.current?.outerHTML);
    }
  }, [text]);

  return (
    <>
      {text && text.length > 0 && (
        <p ref={markdownRef}>
          <ReactMarkdown
            className="markdown-table"
            remarkPlugins={[remarkGfm]}
            rehypePlugins={[rehypeRaw]}
            components={{
              a: ({ node, children }) => {
                const number = children?.toString() || "";
                if (node?.tagName === "a") {
                  const title = _.get(node, "properties.title", "").toString();
                  const [line1, ...rest] = title.split(":");
                  const line2 = rest.join(":").trim();

                  const updatedLine2 = line1.trim().endsWith(".xlsx")
                    ? `Reference from Sheet ${_.get(
                        line2.match(/Sheet Name (.+)/),
                        "[1]",
                        "Unknown"
                      )}`
                    : `Reference from Page ${_.get(
                        line2.match(/Page Number (\d+)/),
                        "[1]",
                        "Unknown"
                      )}`;
                  const formattedTooltip = (
                    <>
                      <div className="tooltip-line-1">{line1}</div>
                      <div className="tooltip-line-2">{updatedLine2}</div>
                    </>
                  );

                  return (
                    <MotifTooltip
                      placement="bottom"
                      hideCloseButton
                      trigger={<MotifBadge  id="instantBadge" className="badgeStyle" value={number} />}
                    >
                      {formattedTooltip}
                    </MotifTooltip>
                  );
                }
                console.warn("Unexpected node type:", children);
                return <a {...node.properties}>{children}</a>;
              },
            }}
          >
            {text}
          </ReactMarkdown>
        </p>
      )}
    </>
  );
}

MarkdownWithoutStream.propTypes = {
  markdownText: PropTypes.string.isRequired,
  setMarkdownResponseHTMLString: PropTypes.func,
};

export default MarkdownWithoutStream;
